import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Image, Input, Message, Segment } from 'semantic-ui-react'
import logo from '../assets/img/logo.png';

class PasswordReset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            sent: false,
            error: false,
            errMsg: ''
        }
        this.submitPWReset = this.submitPWReset.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(e) {
        this.setState({ [e.target.id]: e.target.value });
    }

    submitPWReset(e) {
        e.preventDefault();
        this.setState({ sent: false, error: false });
        this.props.firebaseApp.auth().sendPasswordResetEmail(this.state.email)
        .then(() => {
            console.log('Password reset email sent.');
            this.setState({ sent: true });
        })
        .catch((error) => {
            console.log(error);
            this.setState({ error: true, errMsg: error.message });
        });
    }

    render() {
        const { email, sent, error, errMsg } = this.state;

        return (
            <div className='login-form'>
                {/*
                Heads up! The styles below are necessary for the correct render of this example.
                You can do same with CSS, the main idea is that all the elements up to the `Grid`
                below must have a height of 100%.
                */}
                <style>{`
                body > div,
                body > div > div,
                body > div > div > div.login-form {
                    height: 100%;
                }
                `}</style>
                <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Image src={logo} verticalAlign='middle' size='medium'/>
                        <Header as='h2' color='black' textAlign='center'>
                            Password Reset
                        </Header>
                        <Form size='large' onSubmit={this.submitPWReset}>
                            <Segment stacked>
                                <Form.Input fluid icon='user' iconPosition='left' placeholder='E-mail address' id='email' name='email' value={email} onChange={this.handleInputChange} disabled={sent}/>
                                <Button color='grey' fluid size='large' type='submit' disabled={sent}>
                                    Submit
                                </Button>
                            </Segment>
                        </Form>
                        <Message hidden={sent || error}>
                            Reset password link will be sent to your email
                        </Message>
                        <Message positive hidden={!sent}>
                            Reset password link has been sent to {email}
                        </Message>
                        <Message negative hidden={!error}>
                            {errMsg}
                        </Message>
                    </Grid.Column>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = ({ auth }) => {
    return { firebaseApp: auth.firebaseApp };
}

export default connect(mapStateToProps)(PasswordReset);
